export const toggleSending = {
  data() {
    return {
      sending: false,
    }
  },
  methods: {
    startSending() {
      this.sending = true
    },
    finishSending() {
      this.sending = false
    },
  },
}

export const toggleFetching = {
  data() {
    return {
      isFetching: false,
    }
  },
  methods: {
    startFetching() {
      this.isFetching = true
    },
    finishFetching() {
      this.isFetching = false
    },
  },
}

export const _ = null
